import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromFiltertSelectors from '../../filter/store/filter-inbox.selectors';
import { InboxDelivery } from '../../../core/models';
import { InboxHelper } from './inbox-helper';
import { inboxReducerKey, InboxState } from './inbox.reducer';
import { HelperService } from '../../../core/services/helper.service';

export const selectInbox = createFeatureSelector<InboxState>(inboxReducerKey);

export const getInboxEntities = createSelector(
  selectInbox,
  (state: InboxState) => state && state.entities,
);

export const getIsLoading = createSelector(selectInbox, (state: InboxState) => state.loading);

export const getEntitiesCount = createSelector(
  selectInbox,
  (state: InboxState) => state && state.unreadNumber,
);

export const getPageNumber = createSelector(selectInbox, (state: InboxState) => (
  (state && state.page) || 0
));

export const getInboxListCount = createSelector(
  selectInbox,
  (state: InboxState) => state && state.entities && state.entities.length,
);

export const getScrollPosition = createSelector(
  selectInbox,
  (state: InboxState) => state && state.scrollPosition,
);

export const getInboxList = createSelector(
  getInboxEntities,
  fromFiltertSelectors.getLoadFavorite,
  (list: InboxDelivery[], loadFavorite: boolean) => {
    const inboxList = list.map((delivery: InboxDelivery) => HelperService.cloneDelivery(delivery));
    let filteredList = InboxHelper.filterFavorite(inboxList, loadFavorite);
    filteredList = filteredList.map((delivery: InboxDelivery) => {
      delivery.offlineStatus = 'readyToDownload';
      return delivery;
    });

    return filteredList;
  },
);
